import { Button, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';
import { toast } from 'react-toastify';

type DeleteDraftModalProps = {
  caseId: string;
  onOpenChange: () => void;
  // Return value is only awaited here, never read — different callers' delete endpoints
  // return different shapes (TX Center returns the deleted Case, OPO's returns void).
  deleteDraft: (caseId: string) => Promise<unknown>;
};

export const DeleteDraftModal = ({ onOpenChange, deleteDraft, caseId }: DeleteDraftModalProps) => {
  const handleDelete = async (onClose: () => void) => {
    try {
      await deleteDraft?.(caseId);
      onClose();
      toast.success('Draft case successfully deleted.');
    } catch {
      toast.error('Something went wrong');
    }
  };

  return (
    <Modal
      isOpen
      onOpenChange={onOpenChange}
      size="xl"
      classNames={{
        footer: 'flex flex-col gap-4',
        closeButton: 'text-hl',
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-4">
              <h3 className="text-hl">Delete Draft?</h3>
              <Divider />
            </ModalHeader>
            <ModalBody className="py-6">Are you sure you want to delete Draft?</ModalBody>
            <ModalFooter>
              <Divider />
              <div className="flex gap-3">
                <Button variant="outline" onPress={onClose} className="flex-1">
                  Discard
                </Button>
                <Button variant="solid" onPress={() => handleDelete(onClose)} className="flex-1">
                  Delete
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
